export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '微村云居',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description api请求基础路径
   */
  api_dev: {
    // common: 'http://127.0.0.1:8890',
    // buyer: 'http://127.0.0.1:8888',
    // seller: 'http://127.0.0.1:8889',
    // manager: 'http://127.0.0.1:8887',
    common: 'http://localhost:10002',
    buyer: 'http://localhost:10002',
    seller: 'http://localhost:10002',
    manager: 'http://localhost:10002',
    room: 'http://localhost:10002',

  },
  api_prod: {
    common: 'https://api.weicunyunju.com',
    buyer: 'https://api.weicunyunju.com',
    seller: 'https://api.weicunyunju.com',
    manager: 'https://api.weicunyunju.com',
    room: 'https://api.weicunyunju.com'

    // common: "https://wenlv.yinnima.com",
    // buyer: "https://wenlv.yinnima.com",
    // seller: "https://wenlv.yinnima.com",
    // manager: "https://wenlv.yinnima.com",
    // room: "https://wenlv.yinnima.com"
  },
  /**
   *  @description api请求基础路径前缀
   */
  baseUrlPrefix: '/buyer',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/index.js